import { LOGIN_SUCCESS,LOGIN_FAILURE } from "../../actions/fauluLoanCalculator/auth";

export const initAuth = {
    loginData: null
};

export default (state = initAuth, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return { ...state, loginData: action.data };

        case LOGIN_FAILURE:
            return { ...state, loginData: null };

        default:
            return state;
    }
}